import React, { type FC } from "react";
import NoResultsWithButton from "components/noResultsWithButton/NoResultsWithButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFolderOpen } from "@fortawesome/pro-solid-svg-icons";

export interface ScormsNoResultsProps {
  createButton?: React.ReactElement | null;
  filtered?: boolean;
  title?: string;
  description?: string;
}

const ScormsNoResults: FC<ScormsNoResultsProps> = ({ createButton, filtered, title, description }) => {
  return (
    <NoResultsWithButton
      title={title || "You don't have any SCORM Packages"}
      description={description || "Looks like you don't have any SCORM Packages yet."}
      actionText="the button below to get started."
      icon={<FontAwesomeIcon icon={faFolderOpen} color={"#DEDEDE"} size={"10x"} />}
      actionButton={createButton}
      filtered={filtered}
    />
  );
};

export default ScormsNoResults;
